import type { EthereumAddress, } from "@bracket/types";

export const address: EthereumAddress = "0x65e9aB10f4C4b9005E13195f94E4a2c6db041154";

export const abi = [
	{
		type: "constructor",
		inputs: [
			{
				name: "collaterals",
				type: "address[]",
				internalType: "address[]",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "DECIMAL_PRECISION",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getRate",
		inputs: [
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getRates",
		inputs: [
			{
				name: "tokens",
				type: "address[]",
				internalType: "address[]",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256[]",
				internalType: "uint256[]",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getTotalValue",
		inputs: [
			{
				name: "collaterals",
				type: "tuple[]",
				internalType: "struct IbrktETH.CollateralInfo[]",
				components: [
					{
						name: "collateral",
						type: "address",
						internalType: "address",
					},
					{
						name: "whitelisted",
						type: "bool",
						internalType: "bool",
					},
					{
						name: "totalDeposit",
						type: "uint256",
						internalType: "uint256",
					},
				],
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getTotalValue",
		inputs: [
			{
				name: "tokens",
				type: "address[]",
				internalType: "address[]",
			},
			{
				name: "amounts",
				type: "uint256[]",
				internalType: "uint256[]",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getValue",
		inputs: [
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
			{
				name: "amount",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getValues",
		inputs: [
			{
				name: "tokens",
				type: "address[]",
				internalType: "address[]",
			},
			{
				name: "amounts",
				type: "uint256[]",
				internalType: "uint256[]",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256[]",
				internalType: "uint256[]",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "setRate",
		inputs: [
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
			{
				name: "rate",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "error",
		name: "ZeroAddress",
		inputs: [],
	},
] as const;
